import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const MultiLanguage = makeShortcode("MultiLanguage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MultiLanguage mdxType="MultiLanguage">
      <pre><code parentName="pre" {...{
          "className": "language-js-web"
        }}>{`posthog.opt_out_capturing()
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ios_swift"
        }}>{`PostHogSDK.shared.optOut()
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-android"
        }}>{`PostHog.optOut()
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-react-native"
        }}>{`posthog.opt_out_capturing()
`}</code></pre>
    </MultiLanguage> 

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      